import moment from 'moment';

/**
 * Formatea una fecha de DD/MM/YYYY a DD/MM/YY (año corto)
 * @param date - Fecha en formato DD/MM/YYYY
 * @param inputFormat - Formato de entrada (default: 'DD/MM/YYYY')
 * @param outputFormat - Formato de salida (default: 'DD/MM/YY')
 * @returns Fecha formateada o null si es inválida
 */
export const formatDateShort = (
    date: string | null | undefined,
    inputFormat: string = 'DD/MM/YYYY',
    outputFormat: string = 'DD/MM/YY'
): string | null => {
    if (!date) return null;
    
    const momentDate = moment(date, inputFormat, true); // true para strict parsing
    
    if (!momentDate.isValid()) return null;
    
    return momentDate.format(outputFormat);
};

/**
 * Formatea fecha y hora para mostrar en tablas
 * @param date - Fecha en formato DD/MM/YYYY
 * @param time - Hora en formato HH:mm
 * @param separator - Separador entre fecha y hora (default: ' - ')
 * @returns String formateado "DD/MM/YY - HH:mm" o "---" si hay datos faltantes
 */
export const formatDateTimeForTable = (
    date: string | null | undefined,
    time: string | null | undefined,
    separator: string = ' - '
): string => {
    if (!date || time === null || time === undefined) return '---';
    
    const shortDate = formatDateShort(date);
    
    if (!shortDate) return '---';
    
    return `${shortDate}${separator}${time}`;
};

/**
 * Formatea una fecha completa con diferentes opciones
 * @param date - Fecha a formatear
 * @param options - Opciones de formateo
 * @returns Fecha formateada
 */
export const formatDate = (
    date: string | Date | null | undefined,
    options?: {
        inputFormat?: string;
        outputFormat?: string;
        fallback?: string;
    }
): string => {
    const {
        inputFormat = 'DD/MM/YYYY',
        outputFormat = 'DD/MM/YY',
        fallback = '---'
    } = options || {};
    
    if (!date) return fallback;
    
    const momentDate = typeof date === 'string'
        ? moment(date, inputFormat, true)
        : moment(date);
    
    if (!momentDate.isValid()) return fallback;
    
    return momentDate.format(outputFormat);
};

